import { Component, OnInit } from '@angular/core';
import { routerTransition } from "../animations";
import { AngularFireDatabase } from 'angularfire2/database';

@Component({
  selector: 'app-terms',
  templateUrl: './terms.component.html',
  styleUrls: ['./terms.component.scss'],
  animations: [routerTransition()],
  host: {'[@routerTransition]': ''}
})
export class TermsComponent implements OnInit {

  public termsHTML;
  public termsVersion;

  constructor(private af: AngularFireDatabase) { }

  ngOnInit() {
    this.af.object('/static/terms').$ref.once("value").then(terms => {
      this.termsHTML = terms.val();
    });

    this.af.object('/static/termsVersion').$ref.once("value").then(terms => {
      this.termsVersion = terms.val();
    });
  }

}



// WEBPACK FOOTER //
// /Users/nicholasgerard/Documents/Quibbl/quibbl/src/app/terms/terms.component.ts